import { Box } from '../../../modules/design-system';
import { HeaderPillButton } from './HeaderPillButton';

export interface MyPacksPillProps {
  onClick?: () => void;
  label?: string;
}

/**
 * Modern MyPacks pill — Figma `543:6354` (desktop) / `425:1048` (mobile).
 *
 * Same glass surface on every breakpoint (no D-shape mobile variant), shared
 * with {@link LoginPill} through {@link HeaderPillButton}. The only thing that
 * flexes is the size: h-36/13px on < 600px, h-44/15px on ≥ 600px — matching
 * the rest of the modern pill system.
 *
 * Below 600px the label is swapped for a `Box` glyph (icon-only) so the
 * pill stays compact next to `BalancePill` on stripe-funded operators —
 * the label returns at ≥ 600px where there's room for both.
 */
export function MyPacksPill({ onClick, label = 'My Packs' }: MyPacksPillProps) {
  return (
    <HeaderPillButton
      onClick={onClick}
      ariaLabel={label}
      className="px-3 @[600px]:px-5"
    >
      <Box size={18} className="@[600px]:hidden" />
      <span className="hidden @[600px]:inline">{label}</span>
    </HeaderPillButton>
  );
}
